function LinkSkipTarget() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A target for a "skip" link is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>A "skip" target identifies the location within the page where reading and navigation will resume after a "skip" link is activated.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the element is at the appropriate place within the page.</p>
    </blockquote>
  )
}

export default LinkSkipTarget